import { FocusStyleManager } from "@blueprintjs/core";
import classNames from "classnames";
import React from "react";
import { NavLink } from "react-router-dom";

import { Tab } from "../../pages/Home/home";
import { useAppSelector } from "../../redux/hooks";
import "./header.scss";

export interface HeaderProps {
  tabs: Tab[];
}

export const Header = ({ tabs }: HeaderProps) => {
  FocusStyleManager.onlyShowFocusOnTabs();

  const theme = useAppSelector((state) => state.theme);
  const { teamColor, teamName, teamNickName, teamLogo } = theme;

  const linearGradient = `linear-gradient(to right, #${teamColor}, #${teamColor}80)`;

  return (
    <header className="home-tab-header">
      <div className="header-content" style={{ backgroundImage: linearGradient }}>
        <div className="header-left">
          <div className="header-team-name">
            {teamName} {teamNickName}
          </div>
          <div className="header-menu">
            {tabs.map((tab, key) => (
              <NavLink
                role="button"
                className={({ isActive }) => classNames("header-menu-item", { active: isActive })}
                key={key}
                to={tab}
              >
                {tab}
              </NavLink>
            ))}
          </div>
        </div>
        <div className="header-right">
          <img src={teamLogo} />
        </div>
      </div>
    </header>
  );
};
